// @flow
import Billboard from 'components/billboard/Billboard';
import { connect } from 'react-redux';

import { fetchArticlesBillboard } from 'actions/newsletterActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/billboard/Billboard';

export default connect(
  (state: StateType): StateProps => ({
    news: state.newsletterState.articles,
    status: state.newsletterState.status,
    title: state.settingsState.title,
    description: state.settingsState.description,
    actualite_ffr_vers_ligues: state.settingsState.actualite_ffr_vers_ligues,
    actualite_une: state.settingsState.actualite_une,
    partenaires: state.settingsState.partenaires,
    home: state.settingsState.home,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticlesBillboard: () => dispatch(fetchArticlesBillboard())
  })
)(Billboard);
